import { useGarden } from '../../garden/GardenContext';
import type { ActionLogEntry, GardenElement } from '../../garden/gardenReducer';
import './GlobalLog.css';

interface GlobalLogEntry extends ActionLogEntry {
  elementName: string;
  elementType: string;
}

interface GlobalLogProps {
  onClose: () => void;
}

function groupEntriesByDay(elements: GardenElement[]): [string, GlobalLogEntry[]][] {
  const byDate = new Map<string, GlobalLogEntry[]>();
  for (const element of elements) {
    for (const entry of element.actions) {
      const list = byDate.get(entry.date) || [];
      list.push({ ...entry, elementName: element.name, elementType: element.type });
      byDate.set(entry.date, list);
    }
  }
  return [...byDate.entries()].sort((a, b) => (a[0] < b[0] ? 1 : -1));
}

function GlobalLog({ onClose }: GlobalLogProps) {
  const { elements } = useGarden();
  const groups = groupEntriesByDay(elements);

  return (
    /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions --
       Backdrop click-to-dismiss; the visible "Close" button below is the keyboard-accessible path. */
    <div className="global-log-overlay" onClick={onClose}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions --
          stopPropagation only, not a user action; nothing to make keyboard-accessible. */}
      <div className="global-log" onClick={(e) => e.stopPropagation()}>
        <div className="global-log__header">
          <h2>Activity log</h2>
          <button type="button" onClick={onClose}>
            Close
          </button>
        </div>
        {groups.length === 0 ? (
          <p className="global-log__empty">No actions recorded yet.</p>
        ) : (
          groups.map(([date, entries]) => (
            <div className="global-log__day" key={date}>
              <h3 className="global-log__date">{date}</h3>
              <ul className="global-log__entries">
                {entries.map((entry) => (
                  <li key={entry.id} className="global-log__entry">
                    <span className="global-log__element-name">{entry.elementName}</span>
                    <span className="global-log__note">{entry.note}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default GlobalLog;
